var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dnd/~/lodash/_getPrototype.js
 ** module id = 971
 ** module chunks = 0
 **/